var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_1243)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 30.3553,
    width: 50,
    height: 390.601,
    rx: 25,
    transform: "rotate(-45 -5 30.3553)",
    fill: "url(#paint0_radial_331_1243)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.197,
    y: -5,
    width: 50,
    height: 390.601,
    rx: 25,
    transform: "rotate(45 271.197 -5)",
    fill: "url(#paint1_radial_331_1243)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_331_1243",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 225.656) rotate(90) scale(195.301 25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E1E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_331_1243",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.197 190.301) rotate(90) scale(195.301 25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E1E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_1243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO);
export default __webpack_public_path__ + "static/media/o.f16004c6876f3aa06a581b1a28c3e7d2.svg";
export { ForwardRef as ReactComponent };